import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const PhotoOrSketchCustomizationContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 16
});

export const PhotoOrSketchText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main
}));

export const PhotoOrSketchCustomizationLegendContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 4
});

export const PhotoOrSketchCustomizationLegendText = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	display: "flex"
}));

export const PhotoOrSketchCustomizationLegendTextBold = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	fontWeight: 500,
	color: theme.project.colors.fontColors.secondary
}));

export const StyledUploadButton = styled(Button)({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	padding: "6px 16px",
	textAlign: "center"
});

export const AttachedFilesContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 4
});

export const AttachedFilesContainerTitle = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));
